import { render, staticRenderFns } from "./BotManage.vue?vue&type=template&id=77f6d44c&scoped=true&"
import script from "./BotManage.vue?vue&type=script&lang=js&"
export * from "./BotManage.vue?vue&type=script&lang=js&"
import style0 from "./BotManage.vue?vue&type=style&index=0&id=77f6d44c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f6d44c",
  null
  
)

export default component.exports